"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantStoreItemMappingFacade = void 0;
const tslib_1 = require("tslib");
const qs_1 = require("qs");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
const axios_1 = require("@goparrot/axios");
const common_1 = require("@goparrot/common");
const dto_1 = require("../dto");
class MerchantStoreItemMappingFacade extends axios_1.AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge_1.default.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_MENU_ORCHESTRATOR,
                },
            },
            config,
        ]), interceptors);
    }
    async list(merchantId, { filter, pagination, sort }) {
        const body = { ...filter, sort };
        const config = (0, qs_1.stringify)({ ...pagination });
        return (0, common_1.plainToInstanceWithLVS)(dto_1.ListStoreItemMappingDto, (await this.client.put(`api/v1/merchants/${encodeURIComponent(merchantId)}/store-item-mappings?${config}`, body)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
}
exports.MerchantStoreItemMappingFacade = MerchantStoreItemMappingFacade;
//# sourceMappingURL=MerchantStoreItemMappingFacade.js.map